import React from 'react'

const EmailIcon = props => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.5" width="36" height="36" rx="18" fill="#3249D7" />
      <mask
        id="mask0_835_45245"
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="24"
        height="25"
      >
        <rect x="6" y="6.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_835_45245)">
        <path
          d="M10 27.4992C9.45 27.4992 8.97933 27.3036 8.588 26.9122C8.196 26.5202 8 26.0492 8 25.4992V14.6492C8 14.2992 8.08333 13.9659 8.25 13.6492C8.41667 13.3326 8.65 13.0826 8.95 12.8992L16.975 8.09922C17.1417 7.99922 17.3083 7.92822 17.475 7.88622C17.6417 7.84489 17.8167 7.82422 18 7.82422C18.1833 7.82422 18.3583 7.84489 18.525 7.88622C18.6917 7.92822 18.8583 7.99922 19.025 8.09922L27.05 12.8992C27.35 13.0826 27.5833 13.3326 27.75 13.6492C27.9167 13.9659 28 14.2992 28 14.6492V25.4992C28 26.0492 27.8043 26.5202 27.413 26.9122C27.021 27.3036 26.55 27.4992 26 27.4992H10ZM18 18.9742C18.0833 18.9742 18.1667 18.9659 18.25 18.9492C18.3333 18.9326 18.4167 18.8992 18.5 18.8492L25.8 14.4992L18.5 10.1492C18.4167 10.0992 18.3333 10.0659 18.25 10.0492C18.1667 10.0326 18.0833 10.0242 18 10.0242C17.9167 10.0242 17.8333 10.0326 17.75 10.0492C17.6667 10.0659 17.5833 10.0992 17.5 10.1492L10.2 14.4992L17.5 18.8492C17.5833 18.8992 17.6667 18.9326 17.75 18.9492C17.8333 18.9659 17.9167 18.9742 18 18.9742Z"
          fill="#FAFDFC"
        />
      </g>
    </svg>
  )
}

export default EmailIcon
